// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__utXwf","title":"styles_title__F2aGg","message":"styles_message__icGfi"};